// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import common from './common/common'
import Validations from 'vuelidate'

if (common) {
  common.forEach(function(obj) {
    Vue[obj.type](obj.name, obj.obj)
  })
}

Vue.use(Validations)

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {
    App: App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js